"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGO50GameListScene = exports.IGO50Games = exports.ForestWernat = void 0;
const NinePatch_1 = require("phaser3-rex-plugins/plugins/gameobjects/rendertexture/ninepatch/NinePatch");
const Game_1 = require("./Game");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHContainer_1 = require("./KH/KHContainer");
const Z20TerminalSetup_1 = require("./Z20TerminalSetup");
const IGO50Scenes_1 = require("./IGO50Scenes");
const Z20SceneNames_1 = require("./Z20SceneNames");
exports.ForestWernat = {
    title: 'Forest Wernat',
    sceneKey: Z20SceneNames_1.default.Cutscene,
    icon: 'outer_game_disc',
    icon_gold: 'outer_game_disc_gold',
    icon_cherry: 'outer_game_disc_cherry',
    genre: '1p, Puzzle',
    description: 'Delve deep into the Forest Wernat and lead your player to victory!',
    date: 'November, 1985',
    history: `Inspired by LXS's Planet Zoldath, LCase Games created this game. They were denied licensing and released it as an unlicensed game.`,
    controls: '</>/v/^: MOVE',
    status: () => {
        const streak = Game_1.game.bestStreak.get();
        if (streak > 2)
            return "cherry";
        if (streak > 0)
            return "gold";
        else
            return "normal";
    },
    terminal_codes: [{
            code: 'WOODSEED',
            action: (scene) => {
                // Allows picking seed.
                scene.scene.start(Z20SceneNames_1.default.SeedPicker, { config: Z20TerminalSetup_1.Z20TerminalSetup.SeedPickSetup });
            }
        }, {
            code: 'LONGPAST',
            action: (scene) => {
                // Runs old layout (just mazes, no red herrings, no clearing)
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.PrototypeSetup });
            }
        }, {
            code: 'DULLGAME',
            action: (scene) => {
                // Runs with a static player/rule layout.
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.NoShuffleSetup });
            }
        }, {
            code: 'ONESRUNS',
            action: (scene) => {
                // Runs just mission one forever.
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.LevelForever(1) });
            }
        }, {
            code: 'TWOSCREW',
            action: (scene) => {
                // Runs just mission two forever.
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.LevelForever(2) });
            }
        }, {
            code: '3HASTOBE',
            action: (scene) => {
                // Runs just mission three forever.
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.LevelForever(3) });
            }
        }, {
            code: 'FOUREVER',
            action: (scene) => {
                // Runs just mission four forever.
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.LevelForever(4) });
            }
        }, {
            code: 'FIVEHIVE',
            action: (scene) => {
                // Runs just mission five forever.
                scene.scene.start(Z20SceneNames_1.default.RuleDisplay, { config: Z20TerminalSetup_1.Z20TerminalSetup.LevelForever(5) });
            }
        },],
};
exports.IGO50Games = [exports.ForestWernat];
function formatLongTime(timeInSeconds) {
    timeInSeconds = Math.floor(timeInSeconds);
    const seconds = timeInSeconds % 60;
    const minutes = Math.floor(timeInSeconds / 60) % 60;
    const hours = Math.floor(timeInSeconds / 3600);
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
function fillLine(str) {
    return str.padStart(20, ' ');
}
const tabs = [
    {
        name: "Description",
        icon: "outer_icon_description",
        textLowerUpper: (config) => config.genre,
        textLowerLower: (config) => config.description
    }, {
        name: "Controls",
        icon: "outer_icon_controls",
        textLowerFull: (config) => config.controls,
    }, {
        name: "Time Spent",
        icon: "outer_icon_time",
        textLowerFull: (config) => {
            return `Number of Plays:\n${fillLine(String(Game_1.game.attempts.get()))}\nTotal Playtime:\n${fillLine(formatLongTime(Game_1.game.totalTime.get()))}\nRanking:\n${fillLine("Most Played!")}`;
        },
    }, {
        name: "Statistics",
        icon: "outer_icon_stats",
        textLowerFull: (config) => {
            const highScores = Game_1.game.highScores.get();
            return `Best time:   ${highScores.length > 0 ? `${highScores[0].score.time.toFixed(2)}s` : 'N/A'}\nBest streak: ${Game_1.game.bestStreak.get()}`;
        },
    }, {
        name: "Wins",
        icon: "outer_icon_wins",
        textLowerFull: (config) => {
            const status = exports.ForestWernat.status();
            if (status === 'normal') {
                return 'For Gold... Beat the Game.';
            }
            else if (status === 'gold') {
                return 'For Cherry... Get a streak of 3.';
            }
            else {
                return 'For yourself... see how high you can go!';
            }
        },
    }, {
        name: "History",
        icon: "outer_icon_history",
        textLowerUpper: (config) => config.date,
        textLowerLower: (config) => config.history,
    },
];
class IGO50GameListScene extends Phaser.Scene {
    constructor() {
        super(IGO50Scenes_1.default.GameList);
    }
    static loadAll(scene) {
        scene.load.image('outer_border', 'assets/outer_border.png');
        scene.load.image('outer_tab', 'assets/outer_tab.png');
        scene.load.image('outer_bg', 'assets/outer_bg.png');
        scene.load.image('outer_icon_description', 'assets/outer_icon_description.png');
        scene.load.image('outer_icon_controls', 'assets/outer_icon_controls.png');
        scene.load.image('outer_icon_history', 'assets/outer_icon_history.png');
        scene.load.image('outer_icon_wins', 'assets/outer_icon_wins.png');
        scene.load.image('outer_icon_time', 'assets/outer_icon_time.png');
        scene.load.image('outer_icon_stats', 'assets/outer_icon_stats.png');
        scene.load.image('outer_game_disc', 'assets/outer_game_disc.png');
        scene.load.image('outer_game_disc_gold', 'assets/outer_game_disc_gold.png');
        scene.load.image('outer_game_disc_cherry', 'assets/outer_game_disc_cherry.png');
        scene.load.image('outer_game_disc_shadow', 'assets/outer_game_disc_shadow.png');
    }
    create() {
        // this.audio_scene.play('bg_audio', true, true, 0.5)
        this._controller = Game_1.gameManager.getController();
        this._controller.register(KHInputScene_1.KHInputScene.SharedInput);
        this.config = exports.ForestWernat;
        // this.add.rectangle(0, 0, game.width, game.height, 0xFF0000, 1).setOrigin(0);
        this.add.tileSprite(0, 0, Game_1.game.width, Game_1.game.height, 'outer_bg').setOrigin(0);
        const sy = 8;
        this.add.sprite(16, sy, 'outer_game_disc_shadow').setOrigin(0).setTint(0x202040);
        let icon = this.config.icon;
        const status = this.config.status();
        if (status === "cherry")
            icon = this.config.icon_cherry;
        if (status === "gold")
            icon = this.config.icon_gold;
        this.gameIcon = this.add.sprite(16, sy - 1, icon).setOrigin(0);
        this.tweens.add({
            targets: this.gameIcon,
            y: sy + 1,
            yoyo: true,
            loop: -1,
            duration: 250,
            ease: 'sine.inout',
        });
        const container = new KHContainer_1.KHContainer(this, this.gameIcon.x + 32 + 6 + 8, sy + 8, 159, 95);
        // this.add.existing(container);
        this.container = container;
        const bg = new NinePatch_1.default(this, {
            x: -8, y: -8, width: 175, height: 111,
            key: 'outer_border',
            columns: [7, undefined, 7],
            rows: [7, undefined, 7],
        }).setOrigin(0, 0);
        this.add.existing(bg);
        container.add(bg);
        container.add(this.add.rectangle(0, 25, 159, 8, IGO50GameListScene.HIGHLIGHT_COLOR).setOrigin(0));
        this.tabs = [];
        this.tabIcons = [];
        for (let i = 0; i < tabs.length; i++) {
            const tab = this.add.sprite(i * 16, 16, 'outer_tab').setOrigin(0);
            container.add(tab);
            this.tabs.push(tab);
            const tabIcon = this.add.sprite(i * 16, 16, tabs[i].icon).setOrigin(0);
            container.add(tabIcon);
            this.tabIcons.push(tabIcon);
        }
        const text = this.add.bitmapText(1, 1, 'legacys', this.config.title.toUpperCase()).setOrigin(0, 0);
        container.add(text);
        const description = this.add.bitmapText(1, 26, 'igo50', 'HISTORY').setTint(0x0).setOrigin(0, 0);
        container.add(description);
        this.sectionName = description;
        const textLower = this.add.bitmapText(1, 40, 'igo50', '').setTint(0x63b31d).setOrigin(0, 0);
        container.add(textLower);
        this.textUpper = textLower;
        const textLower2 = this.add.bitmapText(1, 48, 'igo50', '').setTint(0xFFFFFF).setOrigin(0, 0).setMaxWidth(166);
        container.add(textLower2);
        this.textLower = textLower2;
        const textFull = this.add.bitmapText(1, 40, 'igo50', '').setOrigin(0, 0).setMaxWidth(166);
        container.add(textFull);
        this.textFull = textFull;
        this.setSelectedTab(0);
        // this.add.existing(new Z20RuleDisplay(this, game.width/2, game.height/2, this._setup, true));
    }
    setSelectedTab(idx) {
        this.tabIndex = (idx + tabs.length) % tabs.length;
        const selTab = tabs[this.tabIndex];
        this.sectionName.text = selTab.name.toUpperCase();
        this.textFull.text = this.maybeCall(this.config, selTab.textLowerFull);
        this.textLower.text = this.maybeCall(this.config, selTab.textLowerLower);
        this.textUpper.text = this.maybeCall(this.config, selTab.textLowerUpper);
        for (let i = 0; i < this.tabs.length; i++) {
            const tab = this.tabs[i];
            this.container.bringToTop(tab);
            if (i === this.tabIndex) {
                tab.setTint(IGO50GameListScene.HIGHLIGHT_COLOR);
            }
            else {
                tab.setTint(0x707070);
                tab.setDepth(0);
            }
        }
        this.container.bringToTop(this.tabs[this.tabIndex]);
        for (let i = 0; i < this.tabIcons.length; i++) {
            const tab = this.tabIcons[i];
            this.container.bringToTop(tab);
            tab.setTint(i === this.tabIndex ? 0x63b31d : 0xc8c8c8);
        }
    }
    maybeCall(config, fn) {
        if (fn) {
            return fn(config).toUpperCase();
        }
        else
            return '';
    }
    update(time, delta) {
        if (this._controller.getInput(Game_1.Controls.Left).isJustDown()) {
            Game_1.gameManager.addOrGetAudioScene(this).playSfx('move');
            this.setSelectedTab(this.tabIndex - 1);
        }
        else if (this._controller.getInput(Game_1.Controls.Right).isJustDown()) {
            Game_1.gameManager.addOrGetAudioScene(this).playSfx('move');
            this.setSelectedTab(this.tabIndex + 1);
        }
        if (this._controller.getInput(Game_1.Controls.Confirm).isJustDown()) {
            Game_1.gameManager.addOrGetAudioScene(this).playSfx('move');
            this.scene.start(exports.ForestWernat.sceneKey);
        }
    }
}
exports.IGO50GameListScene = IGO50GameListScene;
IGO50GameListScene.HIGHLIGHT_COLOR = 0xa4f022;
